const setters = document.querySelectorAll('[name*="setter-"]');

if (setters.length > 0) {
    startEqualizingData();
}

function copyValue(el) {
    let elName = el.name;
    let selector = '[name="' + elName.slice(7) + '"]';
    document.querySelector(selector).value = el.value;
}

function startEqualizingData() {
    setters.forEach(el => {
        el.addEventListener('input', () => copyValue(el));
    });
}
